import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import api from "@/api/axios";
import HeaderBar from "@/components/HeaderBar";
import ResponsiveSection from "@/components/ResponsiveSection";

export default function RegisterPage() {
  const [nickname, setNickname] = useState("");
  const [telegramId, setTelegramId] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [isInviteCodeLocked, setIsInviteCodeLocked] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // 从链接参数中读取邀请码
    const codeFromUrl = searchParams.get('code');
    if (codeFromUrl) {
      setInviteCode(codeFromUrl);
      setIsInviteCodeLocked(true);
    }
  }, [searchParams]);

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nickname || !telegramId || !code || !password) {
      alert("请填写完整信息");
      return;
    }
    try {
      const res = await api.post("/api/register", {
        user_nickname: nickname,
        telegram_id: telegramId,
        verify_code: code,
        password,
        invite_code: inviteCode || undefined,
      });
      if (res.data.success) {
        alert("注册成功，前往登录页面");
        navigate("/login");
      } else {
        alert(res.data.message || "注册失败");
      }
    } catch (err) {
      console.error(err);
      const detail = axios.isAxiosError(err) ? err.response?.data?.detail : undefined;
      if (detail === "Telegram账号已被注册") {
        alert("Telegram账号已注册，请前往登录页面；如未设置密码，可使用验证码登录。");
      } else {
        alert(typeof detail === "string" ? detail : "注册失败，请稍后重试");
      }
    }
  };

  const openTelegramBot = () => {
    window.open("https://t.me/TGAutoCheckinbot?start=code", "_blank");
  };

  return (
    <div className="public-page min-h-screen flex flex-col">
      <HeaderBar />
      <ResponsiveSection>
        <form
          onSubmit={handleRegister}
          className="public-auth-form"
        >
          <h1>注册账号</h1>

          <label className="public-auth-field">昵称<input
            type="text"
            autoComplete="nickname"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder="昵称"
            required
          /></label>

          <label className="public-auth-field">Telegram 用户名
            <input
              type="text"
              autoComplete="username"
              value={telegramId}
              onChange={(e) => setTelegramId(e.target.value)}
              placeholder="Telegram 用户名 (@开头)"
              required
            />
          </label>

          <p className="public-auth-hint">
            请在 Telegram 与
            <a
              href="https://t.me/TGAutoCheckinbot"
              target="_blank"
              className="text-brand hover:underline mx-1"
              rel="noreferrer"
            >
              @TGAutoCheckinbot
            </a>
            机器人对话获取验证码
          </p>

          <label className="public-auth-field">验证码<div className="public-auth-inline">
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="验证码 (与机器人对话获取)"
              required
            />
                <button
                  type="button"
                  onClick={openTelegramBot}
                  className="public-auth-secondary"
                >
                  获取验证码
                </button>
          </div></label>

          <label className="public-auth-field">邀请码（选填）
            <input
              type="text"
              value={inviteCode}
              onChange={(e) => !isInviteCodeLocked && setInviteCode(e.target.value)}
              placeholder="邀请码 (选填)"
              disabled={isInviteCodeLocked}
              readOnly={isInviteCodeLocked}
            />
          </label>

          <label className="public-auth-field">登录密码<input
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="设置登录密码"
            required
          /></label>

          <button
            type="submit"
            className="public-auth-submit"
          >
            提交注册
          </button>

          <p className="public-auth-footer">
            已有账号？
            <Link to="/login">
              立即登录
            </Link>
          </p>
        </form>
      </ResponsiveSection>
    </div>
  );
}
